import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=1137973c&scoped=true&"
import script from "./SmsList.vue?vue&type=script&lang=js&"
export * from "./SmsList.vue?vue&type=script&lang=js&"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=1137973c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137973c",
  null
  
)

component.options.__file = "SmsList.vue"
export default component.exports